module.exports = {
	"id": "KI",
	"name": "Kiribati",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.00523,
			"12": 0.00523,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.00523,
			"17": null,
			"18": 0.07845,
			"19": null,
			"20": 0.01569,
			"21": null,
			"22": 0.06799,
			"23": null,
			"24": null,
			"25": 0.03661,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.04184,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.00523,
			"37": null,
			"38": 0.01569,
			"39": 0.03138,
			"40": 0.00523,
			"41": null,
			"42": 0.03138,
			"43": 0.05753,
			"44": 0.05753,
			"45": 0.02092,
			"46": null,
			"47": 0.01569,
			"48": 0.02092,
			"49": 0.22489,
			"50": 0.00523,
			"51": 0.55438,
			"52": 0.53346,
			"53": 15.06763,
			"54": 5.36075,
			"55": 0.14644,
			"56": 0.06799,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.02092,
			"4": 0.40794,
			"5": 0.00523,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.00523,
			"13": 0.00523,
			"14": null,
			"15": null,
			"16": 0.00523,
			"17": 0.03661,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.01569,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.00523,
			"28": 0.00523,
			"29": 0.08891,
			"30": null,
			"31": 0.11506,
			"32": 0.06799,
			"33": 0.07322,
			"34": 0.03138,
			"35": 0.00523,
			"36": null,
			"37": null,
			"38": 0.11506,
			"39": 0.02092,
			"40": null,
			"41": 0.00523,
			"42": 0.07845,
			"43": 0.24581,
			"44": 0.33472,
			"45": 0.01569,
			"46": 1.80958,
			"47": 0.71651,
			"48": 0.85249,
			"49": 10.48615,
			"50": 1.03554,
			"51": 0.00523,
			"52": null,
			"3.5": null,
			"3.6": 0.00523
		},
		"opera": {
			"9": 0.00523,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.07845,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.02092,
			"38": 0.04184,
			"39": null,
			"40": 1.21859,
			"41": 0.01569,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.00523
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": null,
			"7": 0.00523,
			"8": 0.01569,
			"9": 0.06799,
			"10": 0.05753,
			"3.1": null,
			"3.2": null,
			"5.1": null,
			"6.1": null,
			"7.1": null,
			"9.1": 0.14644
		},
		"ios_saf": {
			"8": 0,
			"10": 1.07627562864,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.029004382806,
			"8.1-8.4": 0.0535843682348,
			"9.0-9.2": 0.025563184846,
			"9.3": 0.39000243547
		},
		"android": {
			"3": 0,
			"4": 0.130136113695,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0162670142119,
			"4.1": 0.469419552972,
			"4.2-4.3": 1.17354888243,
			"4.4": 2.69102892248,
			"4.4.3-4.4.4": 2.71426751421
		},
		"ie": {
			"6": 0.00524043912176,
			"7": null,
			"8": 0.0943279041916,
			"9": 0.0157213173653,
			"10": 0.922317285429,
			"11": 4.21331305389,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0595527612543,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00165424336818
		},
		"edge": {
			"12": 1.27612,
			"13": 0.44455,
			"14": 0.77927
		},
		"ie_mob": {
			"10": 0.845743746479,
			"11": 3.44338525352
		},
		"bb": {
			"7": 0.0119275,
			"10": null
		},
		"samsung": {
			"0": 5.753826
		},
		"and_uc": {
			"0": 0.610688
		},
		"op_mini": {
			"0": 0.802343995378
		},
		"and_chr": {
			"0": 30.536114
		},
		"and_ff": {
			"0": 0.014313
		}
	},
	"total": 99.3778165
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/KI.json
 ** module id = 563
 ** module chunks = 0
 **/